// extracted by mini-css-extract-plugin
export var dataCell = "_mv-2";
export var dataRow = "_mv-0";
export var headerRow = "_mv-1";